import React, { useState } from 'react';
import { TouchableOpacity } from 'react-native';

import ChatAttachments from '@components/Chat/ChatAttachments.web';
import { ChatHashTagOnboardingTooltip } from '@components/Chat/ChatHashTagOnboardingTooltip.web';
import { ChatInputOptionsBarProps } from '@components/Chat/ChatInputOptionsBar';
import { PulsingHashButton } from '@components/MobileOnboarding/PulsingHashButton';
import { Box } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import { WebIcon } from '@components/shared/Icon/WebIcon';
import theme from '@themes/theme';

export const ChatInputOptionsBar = ({
  onSend,
  onTagPress,
  onImagePress,
  disableSend,
  onDocumentPress,
  onEmojiPress,
  chatId,
  focus = true,
  onCompletedTask,
  onAssignTask,
  onPlusSelect,
  highlightTagButton = false,
  onHighlightTagPress,
  showTagOnboardingTooltip = false,
  onTagOnboardingTryIt,
}: ChatInputOptionsBarProps) => {
  const [isHovered, setIsHovered] = useState(false);
  if (!chatId) return null;

  const iconColor = focus ? 'textPrimary' : 'grey04';
  const onHoverIn = () => setIsHovered(true);
  const onHoverOut = () => setIsHovered(false);

  return (
    <Box flexDirection='row' paddingHorizontal='m'>
      <Box
        justifyContent='space-between'
        alignItems='center'
        flexDirection='row'>
        <Box
          style={{ padding: theme.spacing.xs }}
          borderRadius='xs'
          pointerEvents='auto'
          onMouseEnter={onHoverIn}
          onMouseLeave={onHoverOut}
          backgroundColor={isHovered ? 'grey01' : 'white'}>
          <ChatAttachments
            iconColor={iconColor}
            onPress={() => {
              onPlusSelect && onPlusSelect();
              onHoverOut();
            }}
            onCompletedTask={() => {
              onCompletedTask && onCompletedTask();
            }}
            onAssignTask={() => {
              onAssignTask && onAssignTask();
            }}
          />
        </Box>
        <Box marginLeft='xxs' style={{ position: 'relative' }}>
          {showTagOnboardingTooltip && (
            <Box
              style={{
                position: 'absolute',
                bottom: theme.spacing.xxl,
                left: -theme.spacing.m,
                zIndex: 100,
              }}>
              <ChatHashTagOnboardingTooltip
                onTryIt={onTagOnboardingTryIt ?? (() => {})}
              />
            </Box>
          )}
          {highlightTagButton ? (
            <TouchableOpacity
              accessibilityLabel='Tag'
              onPress={onHighlightTagPress ?? onTagPress}>
              <PulsingHashButton />
            </TouchableOpacity>
          ) : (
            <WebIcon
              accessibilityLabel='Tag'
              name='HashChannel'
              padding='xxxs'
              margin='xxs'
              borderRadius='xs'
              variant='m'
              color='greenSecondary'
              onPress={onTagPress}
            />
          )}
        </Box>

        <Box marginLeft='xxs'>
          <WebIcon
            accessibilityLabel='Add File'
            name='File'
            padding='xxxs'
            margin='xxs'
            borderRadius='xs'
            variant='m'
            color={iconColor}
            onPress={onDocumentPress}
          />
        </Box>

        <Box marginLeft='xxs'>
          <WebIcon
            accessibilityLabel='Gallery'
            name='Image'
            padding='xxxs'
            margin='xxs'
            borderRadius='xs'
            variant='m'
            color={iconColor}
            onPress={onImagePress}
          />
        </Box>
        <Box marginLeft='xxs'>
          <WebIcon
            accessibilityLabel='Add Emoji'
            name='Smile'
            padding='xxxs'
            margin='xxs'
            borderRadius='xs'
            variant='m'
            color={iconColor}
            onPress={onEmojiPress}
          />
        </Box>
      </Box>
      <Box flex={1} alignItems='flex-end'>
        <Icon
          accessibilityLabel='Send message'
          name='Send_v2'
          backgroundColor={
            disableSend || highlightTagButton ? 'grey02' : 'black'
          }
          color='white'
          variant='m'
          onPress={onSend}
          disabled={disableSend || highlightTagButton}
        />
      </Box>
    </Box>
  );
};
